import { useEffect, useState } from 'react';
import {
  getProxyOrderRoomPageListByPreset,
  type OrderRoomPageListPreset,
  type OrderRoomPresetApiResult,
} from '../../../service/storeRevenueApi';

export function useOrderRoomPresetData(
  storeId: number | string,
  preset: OrderRoomPageListPreset,
): {
  data: OrderRoomPresetApiResult | null;
  loading: boolean;
  error: Error | null;
  reload: () => void;
} {
  const [data, setData] = useState<OrderRoomPresetApiResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getProxyOrderRoomPageListByPreset(storeId, preset)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((e) => {
        if (!cancelled) {
          setData(null);
          setError(e instanceof Error ? e : new Error(String(e)));
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [storeId, preset, tick]);

  return {
    data,
    loading,
    error,
    reload: () => setTick((n) => n + 1),
  };
}
